export const teamDirectory = {
  contacts: [
    { name: 'Backend Team Lead', role: 'Senior Backend Engineer', email: 'backend-lead@company.com', slack: '@backend-lead' },
    { name: 'DevOps Engineer', role: 'Infrastructure', email: 'devops@company.com', slack: '@devops-team' },
    { name: 'Database Administrator', role: 'DBA', email: 'dba@company.com', slack: '@database-admin' },
    { name: 'API Product Manager', role: 'Product', email: 'api-pm@company.com', slack: '@api-pm' }
  ],
  mentors: [
    { name: 'Senior Backend Mentor', expertise: 'System Design & Architecture', availability: 'Mon-Fri 2-4 PM' },
    { name: 'Database Mentor', expertise: 'Database Design & Optimization', availability: 'Tue/Thu 10 AM-12 PM' },
    { name: 'Performance Mentor', expertise: 'Backend Performance & Scaling', availability: 'Wed/Fri 3-5 PM' }
  ],
  collaborators: [
    { team: 'Frontend Team', contact: 'frontend-lead@company.com', purpose: 'API Integration' },
    { team: 'Mobile Team', contact: 'mobile-lead@company.com', purpose: 'Mobile API Requirements' },
    { team: 'QA Team', contact: 'qa-lead@company.com', purpose: 'API Testing & Validation' },
    { team: 'Security Team', contact: 'security@company.com', purpose: 'Security Reviews' }
  ],
  channels: {
    primary: '#backend-team',
    announcements: '#backend-announcements',
    help: '#backend-help',
    architecture: '#system-architecture',
    database: '#database-discussions',
    performance: '#performance-optimization',
    security: '#backend-security'
  }
};
